import React, { lazy } from 'react';
import Loadable from 'components/shared/loadable';
import AuthLayout from "layout/auth-layout";

const Login = Loadable(lazy(() => import('pages/auth/login')));
// const PersonalInfo = Loadable(lazy(() => import('pages/auth/personalInfo')));
// const SelectCountry = Loadable(lazy(() => import('pages/auth/country')));
// const PostalCode = Loadable(lazy(() => import('pages/auth/postalcode')));
const CardIssuance = Loadable(lazy(() => import('pages/auth/cardIssuance')));
const NotFound = Loadable(lazy(() => import('pages/not-found')));

const AuthenticationRoutes = {
  path: '/',
  element: <AuthLayout />,
  children: [
    {
      path: '/login',
      element: <Login />,
    },
    // {
    //   path: '/personalInfo',
    //   element: <PersonalInfo />,
    // },
    // {
    //   path: '/country',
    //   element: <SelectCountry />,
    // },
    // {
    //   path: '/postalcode/:country',
    //   element: <PostalCode />,
    // },
    {
      path: '/card-issuance',
      element: <CardIssuance />,
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ],
};

export default AuthenticationRoutes;
